<template>
  <div class="success">
    <common-head title="预约详情" />
    <div class="top-notice">
      <img :src=" datas.status | fifterImg ">
      <div class="text-box">
        <h3> {{datas.status }}！</h3>
        <span> {{ datas.status | fifterStatus }} </span>
      </div>
    </div>
    <div class="main">
      <div class="my-card">
        <van-cell title="编号" :value="datas.reservationCode || '-' " />
        <van-cell title="受种者" :value="datas.profileName" />
        <van-cell title="预约疫苗" :value="datas.vaccineName" />
        <van-cell title="追溯码" :value="datas.traceCode || '-' " />
      </div>
      <div class="my-card">
        <van-cell title="预约门诊" >
          <template #default>
            <span class="custom-title">{{ datas.povName }}</span>
            <div class="custom-tag">
              <van-tag plain color="#50A0FF" v-for="item in datas.types" :key="item">{{ item }}</van-tag>
              <van-tag plain color="#50A0FF" v-if="datas.isTime">24H</van-tag>
            </div>
          </template>
        </van-cell>
        <van-cell title="地址" :value="datas.registerAddress || '-' " />
        <van-cell title="门诊时间" :value="`${datas.reservationDate}`" />
        <van-cell title="签到时间" :value="`${datas.reservationTime} ${datas.week || ''}` " />
        <van-cell title="门诊类型" value="互联网门诊" />
        <van-cell title="医师服务费" :value=" `${datas.price || 0}元`" />
        <div class="notice">
          <p>
            <span>互联网门诊预约须知</span>
            (预约即代表同意以下规则)
          </p>
          <ul>
            <li>1. 医师服务费由医院设定本平台不收取任何额外费用</li>
            <li>2. 停诊将短信通知，请保持手机畅通</li>
            <li>3. 实名制预约，受种者信息不符将无法接种</li>
            <li>4. 门诊为网上就诊，届时医师将拨打患者网络电话，如无法在预约时间内签到视为<span>爽约</span></li>
          </ul>
        </div>
      </div>
      <div class="btn">
        <van-button round @click="action" v-if="datas.status == '待接种'">取消预约</van-button>
      </div>
      <div class="re">
        <template v-if="datas.status == '已取消' || datas.status == '已退款'">
          <van-button type="info" @click="enterHome" round block>重新预约</van-button>
        </template>
        <van-button type="info" v-if="datas.status == '已完成'" @click="enterHome" round block>返回首页</van-button>
      </div>
    </div>
    <!-- 取消弹窗 -->
    <van-action-sheet v-model="show" title="取消预约提醒">
      <div class="cont">
        <div>根据门诊疫苗预约规定：</div>
        <ul>
          <li>第一次取消预约，用户当天不可进行再次预约；</li>
          <li>第二次取消预约，用户本周不可进行再次预约；</li>
          <li>第三次取消预约，用户本月不可进行再次预约。</li>
        </ul>
        <p>请确认，您是否继续取消本次疫苗预约？</p>
        <div class="btn">
          <van-button round @click="cancel">否</van-button>
          <van-button round type="info" @click="confirm(datas.detailId)">是</van-button>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import CommonHead from 'components/CommonHead'
import {getReservationDetail,cancleApplay} from "api/user";
import { Toast } from 'vant'
import {convertToArrTxt} from "utils/handlePovType";

export default {
  components: {
    CommonHead
  },
  data() {
    return {
      show: false,
      id: '',
      status: '',
      datas: {}
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.status = this.$route.query.status;
    this.checkDetail();
  },
  filters: {
    fifterStatus(val) {
      if (val == '待接种') {
        return '预约疫苗待接种，请耐心等候'
      } else if (val == '已取消') {
        return '疫苗预约已取消，如有需要请重新预约'
      } else if (val == '已完成') {
        return '您已完成本次疫苗接种'
      }
    },
    fifterImg(val) {
      if (val == '已取消') {
        return require('@/assets/user/quxiao.png')
      } else if (val == '待接种') {
        return require('@/assets/user/jiezhon.png')
      } else {
        return require('@/assets/imgs/yuyuechenggong.png')
      }
    },
    fifPovType(val) {
      if (val == 1) {
        return '产科门诊'
      } else if (val == 2) {
        return '儿童门诊'
      } else if (val == 3) {
        return '成人门诊'
      } else if (val == 4) {
        return '犬伤门诊'
      }
    }
  },
  methods: {
    confirm(id) {
      let that = this;
      cancleApplay({ id: id}).then(res => {
        if (res.code == 0) {
          Toast('取消成功');
          this.show = false
          setTimeout(() => {
            that.checkDetail();
          })
        }

      })
    },
    cancel() {
      this.show = false
    },
    action() {
      this.show = true
    },
    enterHome() {
      this.$router.push('/home')
    },
    checkDetail() {
      let that = this;
      getReservationDetail(this.id).then(res => {
        console.log(res)
        if (res.code == 0) {
          let data = res.data;
          if (data.povType) {
            if (data.povType.indexOf('4') != -1) {
              data.isTime = true;
            } else {
              data.isTime = false;
            }
            data.types = convertToArrTxt(item.povType)
          } else {
            data.types = []
          }
          that.datas = data;
        }
      })
    },

  }
}
</script>

<style lang="less" scoped>
.success {
  .top-notice {
    height: 123px;
    background: url(../../../assets/imgs/top-notice.jpg) no-repeat center/100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateY(-0.3px);
    img {
      width: 69px;
      height: 50px;
      margin-right: 10px;
    }
    .text-box {
      color: #fff;
      h3 {
        font-size: 18px;
        margin-bottom: 5px;
      }
      span {
        font-size: 12px;
        font-weight: 500;
      }
    }
  }
  .main {
    padding: 13px;

    .my-card {
      padding: 0 !important;
      margin-bottom: 13px;

      .custom-tag {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-top: 7px;
        .van-tag {
          margin-left: 7px;
          margin-bottom: 5px;
        }
      }
    }
    .notice {
      font-size: 12px;
      color: #999;
      padding: 16px;
      span {
        color: var(--orange);
      }
      p {
        margin-bottom: 12px;
      }
    }
    .btn {
      display: flex;
      justify-content: space-between;
      .van-button {
        width: 49%;
      }
    }
    .re {
      padding: 20px 0;
    }
  }
}
.cont {
  padding: 13px;
  color: var(--grey);
  line-height: 22px;
  ul {
    margin-bottom: 30px;
  }
  .btn {
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    .van-button {
      width: 49%;
    }
  }
}
.van-cell__title {
  flex: 0.5;
}
.van-cell__title span {
  color: #666;
}
.van-cell__value span {
  color: #333;
}
</style>